import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { GoogleAnalyticsBootstrap } from "./hooks/useGoogleAnalytics";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./routes/ScrollToTop";
import AppRoutes from "./routes/AppRoutes";
import { Provider } from "react-redux";
import { store } from "./hooks";

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <Provider store={store}>
        <Router>
          <ScrollToTop />
          <GoogleAnalyticsBootstrap />
          <AppRoutes />
        </Router>
      </Provider>
    </HelmetProvider>
  );
};

export default App;
